"use strict";
/**
 * Polymarket US venue API — every client call that ultimately hits PM-US.
 *
 * ORDER PATH: placePolymarketUsOrder() → POST /polymarket-us/orders
 *   → server src/server/routes/polymarket-us/orders.ts
 *   → src/server/polymarket-us/frontend-orders.ts → PM-US exchange API.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.listPolymarketUsMarkets = listPolymarketUsMarkets;
exports.listPolymarketUsCategories = listPolymarketUsCategories;
exports.listPolymarketUsSports = listPolymarketUsSports;
exports.listPolymarketUsEvents = listPolymarketUsEvents;
exports.getPolymarketUsEventMarkets = getPolymarketUsEventMarkets;
exports.placePolymarketUsOrder = placePolymarketUsOrder;
const request_1 = require("./request");
async function listPolymarketUsMarkets(params = {}) {
    const query = {};
    if (params.limit !== undefined)
        query.limit = params.limit;
    if (params.offset !== undefined)
        query.offset = params.offset;
    if (params.active !== undefined)
        query.active = params.active;
    if (params.closed !== undefined)
        query.closed = params.closed;
    if (params.archived !== undefined)
        query.archived = params.archived;
    if (params.categories?.length)
        query.categories = params.categories.join(",");
    if (params.sportsMarketTypes?.length) {
        query.sportsMarketTypes = params.sportsMarketTypes.join(",");
    }
    if (params.volumeNumMin !== undefined)
        query.volumeNumMin = params.volumeNumMin;
    if (params.liquidityNumMin !== undefined)
        query.liquidityNumMin = params.liquidityNumMin;
    return (0, request_1.apiRequest)("GET", "/polymarket-us/markets", { params: query });
}
async function listPolymarketUsCategories() {
    return (0, request_1.apiRequest)("GET", "/polymarket-us/categories");
}
async function listPolymarketUsSports() {
    return (0, request_1.apiRequest)("GET", "/polymarket-us/sports");
}
/**
 * List PM-US events for a sport/league.
 *
 * Events come back WITHOUT nested markets: the upstream payload embeds every
 * market of every event and runs to megabytes for a busy league (measured
 * 12.2 MB for 18 MLB events), which is what used to break the load. Pair this
 * with `getPolymarketUsEventMarkets()` on selection.
 *
 * Pass `include: ["markets"]` only if you genuinely need every market of every
 * event in one shot, and expect a very large response.
 */
async function listPolymarketUsEvents(params) {
    const query = {};
    if (params.limit !== undefined)
        query.limit = params.limit;
    if (params.active !== undefined)
        query.active = params.active;
    if (params.closed !== undefined)
        query.closed = params.closed;
    if (params.ended !== undefined)
        query.ended = params.ended;
    if (params.startTimeMin)
        query.startTimeMin = params.startTimeMin;
    if (params.startDate)
        query.startDate = params.startDate;
    if (params.endDate)
        query.endDate = params.endDate;
    if (params.tagSlug)
        query.tagSlug = params.tagSlug;
    if (params.include?.length)
        query.include = params.include.join(",");
    if (params.gamesOnly)
        query.gamesOnly = true;
    return (0, request_1.apiRequest)("GET", "/polymarket-us/events", { params: query });
}
/**
 * Fetch one PM-US event's markets on demand.
 *
 * @param eventId - Gateway event id (numeric) or event slug, as carried on the
 *   event objects returned by `listPolymarketUsEvents()`.
 */
async function getPolymarketUsEventMarkets(eventId) {
    if (!eventId) {
        throw new Error("Event id is required");
    }
    return (0, request_1.apiRequest)("GET", `/polymarket-us/events/${encodeURIComponent(eventId)}/markets`);
}
async function placePolymarketUsOrder(request) {
    return (0, request_1.apiRequest)("POST", "/polymarket-us/orders", { body: request });
}
